<template>
  <div class="pt-4">
    <template v-if="status_code == 201">
      <p class="text-danger">{{status_message}}</p>
    </template>
    <template v-else>
    <b-row class="d-print-none mb-3">
      <b-col cols="6" xl="6" lg="6" md="6" sm="6" xs="6" class="float-left pl-2 mt-2">
        <GlobalDateRangePicker
          class="ml-3 date_range_pick_with_icon"
          :fromDate="from_date"
          v-on:setDateRange="getDateRange($event)"
          :toDate="to_date"
        />
      </b-col>
      <b-col cols="6" xl="6" lg="6" md="6" sm="6" xs="6" class="pr-2">
        <b-button-group variant="light" class="float-right mr-3">
          <b-button size="sm" variant="light" @click="printcustomerstatement()">
            <i class="la la-print la-lg"></i>
          </b-button>
          <b-button @click="emailstatement()" variant="light" size="sm" title="email">
            <i class="la la-envelope-o la-lg"></i>
          </b-button>
          <b-button size="sm" variant="light" @click="getstatementdetails()">
            <i
              :class="{'fa fa-refresh' : true,  'fa-spin' : spinner}"
              v-b-tooltip
              placement="bottom"
              title="Refresh Statement"
            ></i>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) for CUSTOMER STATEMENT-->
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'customer-a4-standard-portrait-page':'customer-a4-standard-landscape-page':field.temp_prop.orientation==0?'customer-a5-standard-portrait-page':'customer-a5-standard-landscape-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
   <div class="print-template customer-statement"   :style="{'font-size':(field.temp_prop.font_size||8)+'pt !important','color':(field.temp_prop.temp_font_color.hex||'#000'),'background':(field.temp_prop.is_temp_bg_color==1?field.temp_prop.temp_bg_color.hex:'#fff')}">
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
           :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <!-- Page Heading -->
          <div class="invoice-top-heading" style="word-break:break-word !important">
            <h5
              class="text-center"
              :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
              style="margin-bottom:0px"
            >{{field.header_prop.doc_title}} {{ list.main_detail.cus_display_name }}</h5>
            <p
              style="margin-top:0px;margin-bottom:0px" :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}"
              class="text-center"
            >{{getDateFormat(from_date)}} To {{getDateFormat(to_date)}}</p>
          </div>
          <!-- First Block -->
          <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div style="width:30% !important;word-break:break-word">
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
              >{{ org_details.comp_name }}</div>
              <div v-if="field.header_prop.show_org_addr" class="custom-invoice-address">
               
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}">{{ org_details.addr_line_1 }}</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}">{{ org_details.addr_line_2 }}</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}">{{ org_details.org_city }} {{ getDetails($AppDetails.state_details,org_details.org_state,'state_name') }}</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}">
                    {{ getDetails($AppDetails.country_details,org_details.org_country,'country_name') }}
                    {{ org_details.org_pincode }}
                  </p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}" v-if=" org_details.org_mail">Mail: {{ org_details.org_mail }}</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}">
                    {{field.header_prop.phone}}:
                    {{ org_details.phone_no }}
                  </p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt !important'}"
                    style="margin-bottom:0px;"
                    v-if="org_details.gst_type != 3 && org_details.gst_no != ''"
                  >
                    GSTIN:
                    {{ org_details.gst_no }}
                  </p>
              </div>
            </div>
            <!-- Organization Logo -->
            <div>
              <!-- Max width for Logo Block -->
              <!-- Logo Image -->
              <!-- <img
                v-if="field.header_prop.show_logo&&imageSrc==''"
                src="@/assets/logo/Shanki-logo.png"
                :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
                style="max-width:300px;max-height:183.05px"
              />-->
              <img
                v-if="field.header_prop.show_logo&&imageSrc!=''&&org_details.org_logo != '' && org_details.org_logo != null"
                v-bind:src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
                style="max-width:300px;max-height:183.05px"
              />
            </div>
          </div>
          <!-- End of First Block -->
          <!-- Second Block -->
          <div class="invoice-second-block" style="display:flow-root">
            <div
              style="display:flex;justify-content: space-between;width:100% !important;word-break:break-word"
            >
              <!-- Bill Address -->
              <div v-if="field.header_prop.doc_bill_to.show" style="width:40% !important">
                <div
                  :style="{'font-size':field.temp_prop.font_size+'pt','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.temp_prop.temp_label_color.hex}"
                  style="margin-bottom:1px;font-weight:700;padding: 2px 0px 2px 2px;width:200px" 
                >To</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;color:#000;"
                >{{ list.main_detail.cus_display_name }}</div>
                <div class="custom-invoice-address">
                  <template v-if="typeof list.customer_addr[1] !== 'undefined'">
                    <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">{{ list.customer_addr[1].cus_addr_line_1 }}</p>
                    <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">{{ list.customer_addr[1].cus_addr_line_2 }}</p>
                    <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">{{ list.customer_addr[1].cus_city }} {{ getDetails($AppDetails.state_details,list.customer_addr[1].cus_state,'state_name') }}</p>
                    <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">{{ getDetails($AppDetails.country_details,list.customer_addr[1].cus_country,'country_name') }} {{ list.customer_addr[1].cus_pincode }}</p>
                  </template>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                    {{ list.main_detail.cus_gst_type == 3 ? 'Pan No' : 'GSTIN' }}:
                    {{ list.main_detail.cus_gst_no || list.main_detail.cus_pan_no }}
                  </p>
                </div>
              </div>
              <!-- Invoice Details-->
              <div
                v-if="field.header_prop.show_acc_sum"
                style="width:40% !important;word-break:break-word"
              >
                <div
                  :style="{'color':field.temp_prop.temp_label_color.hex,'font-size':field.temp_prop.font_size+'pt','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871'}"
                  style="margin-bottom:1px;font-weight:700;color: rgb(255, 255, 255);padding: 2px 0px 2px 6px;word-break:break-word"
                  
                >{{field.header_prop.total_sum_label}}</div>
                <table class="custom-invoice-details-table" :style="{'font-size':field.temp_prop.font_size+'pt'}">
                  <tbody>
                    <tr v-if="field.header_prop.open_bal.show">
                      <td class="text-left" :style="{'color':field.temp_prop.temp_label_color.hex}">{{field.header_prop.open_bal.label}}</td>
                      <td class="text-right" style="width:150px !important" :style="{'color':field.temp_prop.temp_font_color.hex}">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        list.main_detail.cus_currency,
                        "currency_symbol"
                        )}} {{ parseFloat(total().opening_balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </td>
                    </tr>
                    <tr v-if="field.header_prop.inv_amt.show">
                      <td class="text-left" :style="{'color':field.temp_prop.temp_label_color.hex}">{{field.header_prop.inv_amt.label}}</td>
                      <td class="text-right" style="width:150px !important" :style="{'color':field.temp_prop.temp_font_color.hex}">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        list.main_detail.cus_currency,
                        "currency_symbol"
                        )}} {{ parseFloat(total().invoiced_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </td>
                    </tr>
                    <tr v-if="field.header_prop.paid_amt.show">
                      <td class="text-left" :style="{'color':field.temp_prop.temp_label_color.hex}">{{field.header_prop.paid_amt.label}}</td>
                      <td class="text-right" style="width:150px !important" :style="{'color':field.temp_prop.temp_font_color.hex}">
                        {{ getDetails(
                        $AppDetails.currency_details,
                        list.main_detail.cus_currency,
                        "currency_symbol"
                        )}} {{ parseFloat(total().paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </td>
                    </tr>
                    <tr v-if="field.header_prop.bal_due.show">
                      <td
                        class="text-left semi-bold"
                        style="border-top: 1px dashed #ededed;font-weight:700"
                        :style="{'color':field.temp_prop.temp_label_color.hex}"
                      >{{field.header_prop.bal_due.label}}</td>
                      <td
                        class="text-right semi-bold"
                        style="border-top: 1px dashed #ededed;width:150px !important;font-weight:700" :style="{'color':field.temp_prop.temp_font_color.hex}"
                      >
                        {{ getDetails(
                        $AppDetails.currency_details,
                        list.main_detail.cus_currency,
                        "currency_symbol"
                        )}} {{ parseFloat(total().due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--End of Second Block -->
          <!-- Fifth Block -->
          <div class="invoice-fifth-block" style="margin-top:15px;">
            <table class="custom-invoice-line-item-table">
              <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                 style="word-break:break-word"
              >
                <th
                  v-if="field.item_prop.label.date.show"
                  style="width:15%;"
                  class="text-left semi-bold"
                >{{field.item_prop.label.date.label}}</th>
                <th
                  v-if="field.item_prop.label.transaction.show"
                  style="width:15%;"
                  class="semi-bold"
                >{{field.item_prop.label.transaction.label}}</th>
                <th
                  v-if="field.item_prop.label.detail.show"
                  style="width:20%;"
                  class="semi-bold"
                >{{field.item_prop.label.detail.label}}</th>
                <th
                  v-if="field.item_prop.label.amt.show"
                  style="width:10%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.amt.label}}</th>
                <th
                  v-if="field.item_prop.label.payments.show"
                  style="width:10%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.payments.label}}</th>
                 <th
                  v-if="field.item_prop.label.refund.show"
                  style="width:10%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.refund.label}}</th>
                <th
                  v-if="field.item_prop.label.bal.show"
                  style="width:15%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.bal.label}}</th>
              </thead>
              <tbody style="background:#fff;color:#000;" :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                <tr
                  :style="{'background': parseFloat(index+1) % 2 == 0 ? field.item_prop.layout.even_row.hex : field.item_prop.layout.odd_row.hex}"
                  v-for="(statementdetail,index) in statementdetails"
                  :key="statementdetail.id"
                  style="background:#fff;"
                >
                  <td
                    style="border-bottom:1px solid #ededed;width:15%;word-break: break-word"
                    v-if="field.item_prop.label.date.show"
                  >{{ getDateFormat(statementdetail.date) }}</td>
                  <td
                    style="border-bottom:1px solid #ededed;width:20%;word-break: break-word"
                    v-if="field.item_prop.label.transaction.show"
                    v-html="statementdetail.transactions"
                  ></td>
                  <td
                    style="border-bottom:1px solid #ededed;width:15%;white-space:pre;word-break: break-word"
                    v-if="field.item_prop.label.detail.show"
                  >
                  <span  v-if="field.header_prop.doc_ref_no.show&&statementdetail.ref_no">{{field.header_prop.doc_ref_no.label}} {{statementdetail.ref_no}}</span>
                  <p style="padding-bottom:0px;margin-bottom:0px">{{statementdetail.details}}</p>
                   <span v-if="field.item_prop.label.pjt.show_pjt&&statementdetail.pjt_id"> {{statementdetail.pjt_id}}</span>
                  
                 </td>
                  <td
                    style="border-bottom:1px solid #ededed;width:10%;word-break: break-word"
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                  >{{ statementdetail.amounts == '' ? '' : parseFloat(statementdetail.amounts).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    style="border-bottom:1px solid #ededed;width:15%;word-break: break-word"
                    v-if="field.item_prop.label.payments.show"
                    class="text-right"
                  >{{ statementdetail.payments == '' ? '' : parseFloat(statementdetail.payments).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                   <td
                    style="border-bottom:1px solid #ededed;width:10%;word-break: break-word"
                    v-if="field.item_prop.label.refund.show"
                    class="text-right"
                  >{{statementdetail.refund_amount?(statementdetail.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) :''}}</td>
                  <td
                    style="border-bottom:1px solid #ededed;width:15%;word-break: break-word"
                    v-if="field.item_prop.label.bal.show"
                    class="text-right"
                  >{{ statementdetail.include == 1 ? parseFloat(statementdetail.balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of Fifth Block -->
          <!-- Sixth Block -->
          <!-- Subtotal,total -->
          <!-- Tax,Discount -->
          <!-- Balance Due -->
          <div
            v-if="field.footer_prop.show_aging_detl"
            class="invoice-sixth-block balance-due-table"
            style="display: flow-root;"
          >
            <table class="table statement-due-table">
              <thead   :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}">
                <tr>
                  <th colspan="5" class="text-center">Overdue</th>
                  <th rowspan="2" class="text-right">Balance Due</th>
                </tr>
                 <tr >
                  <th class="text-right">Current</th>
                  <th class="text-right">1-15 days</th>
                  <th class="text-right">16-30 days</th>
                  <th class="text-right">31-45 days</th>
                  <th class="text-right">Above 45 days</th>
                </tr>
              </thead>
             <tbody :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                <tr :style="{'background':field.item_prop.layout.odd_row.hex}" >
                  <td
                    class="text-right"
                    style="word-break: break-word"
                  >{{ statementdetails[0].current }}</td>
                  <td
                    class="text-right"
                    style="word-break: break-word"
                  >{{ statementdetails[0].overdue_1_15_amt }}</td>
                  <td
                    class="text-right"
                    style="word-break: break-word"
                  >{{ statementdetails[0].overdue_16_30_amt }}</td>
                  <td
                    class="text-right"
                    style="word-break: break-word"
                  >{{ statementdetails[0].overdue_31_45_amt }}</td>
                  <td
                    class="text-right"
                    style="word-break: break-word"
                  >{{ statementdetails[0].overdue_abv_45_amt }}</td>
                  <td class="text-right fw-semi-bold" style="word-break: break-word">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.main_detail.cus_currency,
                    "currency_symbol"
                    )}} {{ parseFloat(total().due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="invoice-sixth-block balance-due-block" style="display: flow-root;">
            <table class="custom-invoice-total-table float-right" style="width:50%;margin:4px;">
             <tbody  :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                <tr :style="{'background':field.item_prop.layout.odd_row.hex}"  >
                  <td class="text-right semi-bold" style="color:#000" :style="{'font-size':field.temp_prop.font_size+'pt'}">Balance Due</td>
                  <td class="text-right semi-bold" style="color:#000" :style="{'font-size':field.temp_prop.font_size+'pt'}">
                    {{ getDetails(
                    $AppDetails.currency_details,
                    list.main_detail.cus_currency,
                    "currency_symbol"
                    )}} {{ parseFloat(total().due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of sixth block -->
        </div>
        <!-- Body End -->
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff'}"
        ></div>
      </div>
    </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import { formatDate } from "@/mixins/formatDate";
import { notificationMixin } from "@/mixins/notification";
export default {
  mixins: [formatDate,notificationMixin],

  data() {
    return {
      mail_id: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      spinner: false,
      imageSrc: `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5v
                    cmcvMjAwMC9zdmciIHdpZHRoPSIxOTEiIGhlaWdodD0iMTQxIj48cmVjdCB3aWR0aD0
                    iMTkxIiBoZWlnaHQ9IjE0MSIgZmlsbD0iI2VlZSIvPjx0ZXh0IHRleHQtYW5jaG9yPS
                    JtaWRkbGUiIHg9Ijk1LjUiIHk9IjcwLjUiIHN0eWxlPSJmaWxsOiNhYWE7Zm9udC13Z
                    WlnaHQ6Ym9sZDtmb250LXNpemU6MTJweDtmb250LWZhbWlseTpBcmlhbCxIZWx2ZXRp
                    Y2Esc2Fucy1zZXJpZjtkb21pbmFudC1iYXNlbGluZTpjZW50cmFsIj4xOTF4MTQxPC9
                    0ZXh0Pjwvc3ZnPg==`,

      from_date: this.formatDate(moment().startOf("month")),
      to_date: this.formatDate(moment().endOf("month")),
      destroyed: true,
      
    };
  },
  methods: {
    async emailstatement() {
      await this.getstatementdetails();
      if (this.status_code != 404) {
        this.$router.push({
          name: "Email",
          query: {
            tns_type: "Customer Statement",
            id: this.$route.params.id,
            tns_date: this.from_date,
            from_date: this.from_date,
            to_date: this.to_date,
            is_export:
              this.list.main_detail.cus_currency !=
              this.$AppDetails.organization.org_currency
                ? 2
                : 1,
            cus_id: this.list.main_detail.cus_id,
            cus_name: this.list.main_detail.cus_display_name,
            tns_no: this.list.main_detail.cus_code,
            tns_mail: this.list.main_detail.cus_mail,
            tns_currency: this.list.main_detail.cus_currency,
            date_format: this.org_details.date_format
          }
        });
      }
    },
    async printcustomerstatement() {
      await this.getstatementdetails();
      if (this.status_code != 404) {
        document.title =
          this.list.main_detail.cus_display_name +
          " / " +
         this.getDateFormat(this.from_date)+'To'+this.getDateFormat(this.to_date)

        var id =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "customer-a4-standard-portrait-page"
              : "customer-a4-standard-landscape-page"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "customer-a5-standard-portrait-page"
              : "customer-a5-standard-landscape-page"
            : "";
        var style = "standard";
        var size =
          this.field.temp_prop.paper_size == 0
            ? this.field.temp_prop.orientation == 0
              ? "size:A4;"
              : "size:A4 landscape;"
            : this.field.temp_prop.paper_size == 1
            ? this.field.temp_prop.orientation == 0
              ? "size:A5;"
              : "size:A5 landscape;"
            : "";
        var win;
        const element = document.getElementById(id);
        win = window.open(
          "",
          "Title",
          "fullscreen=yes",
          "titlebar=yes",
          "scrollbars=yes"
        );
        win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${process.env.VUE_APP_INVOICE_API_URL}/css/print/${style}.css">
              </head>
              <body class="${id}">
              ${element.innerHTML}
              </body>
            </html>
          `);
        if (navigator.userAgent.indexOf("Safari") != -1) {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
          }, 500);
          setTimeout(() => {
            win.close();
          }, 5000);
        } else {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
            win.close();
          }, 500);
        }
      }
    },
    // daterange picker updated method
    async getDateRange(event) {
      this.from_date = await event.startDate;
      this.to_date = await event.endDate;
      if (!this.destroyed) {
        await this.getstatementdetails();
      }
    },
    createdData() {
      this.destroyed = false;
      this.getstatementdetails();
    },
    async getstatementdetails() {
      var data = JSON.stringify({
        id: this.$route.params.id,
        migration_date: this.org_details.migration_date,
        from_date: this.from_date,
        to_date: this.to_date,
        is_export:
          this.list.main_detail.cus_currency !=
          this.$AppDetails.organization.org_currency
            ? 2
            : 1,
        currency: this.getDetails(
          this.$AppDetails.currency_details,
          this.list.main_detail.cus_currency,
          "currency_symbol"
        ),
        date_format: this.org_details.date_format
      });
      this.spinner = await true;
      await this.$store.dispatch("customer/fetchcustomerstatementLists", data).then(response=>{
        if(response.data.code == 201){
        window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.message,
            type: response.data.type,
            showCloseButton: true,
          });
        }
       
      })
      this.spinner = await false;
    },
    total() {
      var opening_balance = 0;
      var invoiced_amount = 0;
      var paid_amount = 0;
      var row_balance = 0;
      for (var i = 0; i < this.statementdetails.length; i++) {
        var OB = 0;
        var IA = 0;
        var AP = 0;
        //  to calculate each row balance amount
        if (
          this.statementdetails[i].type != "AP" &&
          this.statementdetails[i].include == 1
        ) {
          row_balance +=
            this.statementdetails[i].amounts != "" &&
            this.statementdetails[i].amounts != null &&
            typeof this.statementdetails[i].amounts != "undefined"
              ? parseFloat(this.statementdetails[i].amounts)
              : parseFloat(0);
        } else {
          row_balance +=
            this.statementdetails[i].payments != "" &&
            this.statementdetails[i].payments != null &&
            typeof this.statementdetails[i].payments != "undefined"
              ? parseFloat(this.statementdetails[i].payments)
              : parseFloat(0);
        }
        //  to calculate opening balance,paid amount and invoiced amount
        if (
          this.statementdetails[i].type == "OB" &&
          this.statementdetails[i].include == 1
        ) {
          OB =
            this.statementdetails[i].amounts != "" &&
            this.statementdetails[i].amounts != null &&
            typeof this.statementdetails[i].amounts != "undefined"
              ? this.statementdetails[i].amounts
              : 0;
        } else if (
          this.statementdetails[i].type == "IA" &&
          this.statementdetails[i].include == 1
        ) {
          IA =
            this.statementdetails[i].amounts != "" &&
            this.statementdetails[i].amounts != null &&
            typeof this.statementdetails[i].amounts != "undefined"
              ? this.statementdetails[i].amounts
              : 0;
        } else if (
          this.statementdetails[i].type == "AP" &&
          this.statementdetails[i].include == 1
        ) {
          AP =
            this.statementdetails[i].payments != "" &&
            this.statementdetails[i].payments != null &&
            typeof this.statementdetails[i].payments != "undefined"
              ? this.statementdetails[i].payments
              : 0;
        }
        opening_balance += parseFloat(OB);
        invoiced_amount += parseFloat(IA);
        paid_amount += parseFloat(AP);
        this.statementdetails[i].balance = row_balance;
      }
      return {
        opening_balance: parseFloat(opening_balance).toFixed(2),
        invoiced_amount: parseFloat(invoiced_amount).toFixed(2),
        paid_amount: parseFloat(-paid_amount).toFixed(2),
        due_amount: parseFloat(
          opening_balance + invoiced_amount + paid_amount
        ).toFixed(2)
      };
    }
  },
  async created() {
    this.mail_id = this.list.main_detail.cus_mail;
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
  },
  computed: {
    ...mapState({
      status_code: state => state.customer.status_code,
      status_message: state => state.customer.status_message,
      status_type: state => state.customer.status_type,
      list: state => state.customer.listView,
      statementdetails: state => state.customer.statementdetails,
      email: state => state.customer.email,
      field: state =>
        state.permission.print_settings_details["Customer Statement"]
          .template_list
    }),
    ...mapGetters(["org_details", "cus_settings_details"])
  }
};
</script>
<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page,
#customer-a4-standard-portrait-page {
  width: 21cm;
  min-height: fit-content !important;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page,
#customer-a4-standard-landscape-page {
  width: 29.7cm;
  min-height: fit-content !important;
}
//A5 standard portrait
#a5-standard-portrait-page,
#customer-a5-standard-portrait-page {
  width: 14.8cm;
  min-height: fit-content !important;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page,
#customer-a5-standard-landscape-page {
  width: 21cm;
  min-height: fit-content !important;
}
#a4-standard-portrait-page .print-template,
#customer-a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout,
#customer-a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}
#a5-standard-landscape-page .print-template,
#customer-a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template,
#customer-a4-standard-landscape-page .print-template {
  zoom: 80%;
}
.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
.customer-statement table.custom-invoice-details-table > tbody > tr > td,
.statement-due-table > tbody > tr > td {
  padding: 6px !important;
}
.balance-due-table {
  margin-top: 20px;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table,
table.statement-due-table {
  width: 100% !important;
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.customer-statement table.custom-invoice-line-item-table tbody > tr > td,
.customer-statement table.custom-invoice-line-item-table thead > th {
  padding: 4px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
table.statement-due-table thead > tr > th,
table.statement-due-table tbody > tr > td {
  border: 1px solid #ededed;
  padding: 4px !important;
}
table.statement-due-table {
  border-top: 1px solid #ededed;
  padding: 4px !important;
}
@media (min-width: 10px) and (max-width: 768px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 36%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 26%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 52%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 36%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 50%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 35%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 70%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 50%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 73%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 55%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 100%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 80%;
  }
}
@media (min-width: 1281px) and (max-width: 1366px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 90%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 64%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 90%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 86%;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 75%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 70%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 97%;
  }
}
@media (min-width: 1605px) {
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 122%;
  }
}
</style>